import { Stack } from "@mui/material"
import { GenericTextField } from "../generic/GenericTextField"
import { Fragment } from "react"

export const JobOfferForm = ({ formik }) => {
  return (
    <Fragment>
      <GenericTextField
        value={formik.values?.job_position}
        onChange={(event) => formik.setFieldValue('job_position', event.target.value)}
        label={'Job Position'}
        placeholder={'Frontend Developer'}
        error={Boolean(formik.errors?.job_position)}
        helperText={formik.errors?.job_position}
      />
      <GenericTextField
        value={formik.values?.company}
        onChange={(event) => formik.setFieldValue('company', event.target.value)}
        label={'Company'}
        placeholder={'Microsoft'}
        error={Boolean(formik.errors?.company)}
        helperText={formik.errors?.company}
      />
      <GenericTextField
        value={formik.values?.message}
        onChange={(event) => formik.setFieldValue('message', event.target.value)}
        multiline
        rows={6}
        label={'Additional Information'}
        placeholder={'Describe the job details (duties, responsibilities, salary, etc.)'}
        error={Boolean(formik.errors?.message)}
        helperText={formik.errors?.message}
      />
    </Fragment>
  )
}